import { render, staticRenderFns } from "./FormsDemo.vue?vue&type=template&id=227d12b4&scoped=true&"
import script from "./FormsDemo.vue?vue&type=script&lang=js&"
export * from "./FormsDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d12b4",
  null
  
)

export default component.exports